export const productTypes = [
  {
    id: 'ptype_servico',
    organizationId: 'org_3la_labs',
    name: 'Serviço',
    active: true,
  },
  {
    id: 'ptype_produto',
    organizationId: 'org_3la_labs',
    name: 'Produto',
    active: true,
  },
];
